<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
        attachments: Array.isArray(cannedMessage.attachments)
          ? cannedMessage.attachments
          : [],
        attachmentUrl: cannedMessage.attachment_url || null,
        attachmentSignedId: cannedMessage.attachment_signed_id || null,
        fileName: cannedMessage.file_name || '',
        fileType: cannedMessage.file_type || '',
        fileSize: cannedMessage.file_size || 0,
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', {
        text: item.description || '',
        attachments: Array.isArray(item.attachments) ? item.attachments : [],
        attachmentUrl: item.attachmentUrl || null,
        attachmentSignedId: item.attachmentSignedId || null,
        fileName: item.fileName || '',
        fileType: item.fileType || '',
        fileSize: item.fileSize || 0,
      });
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
